var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.906979 0C0.406069 0 0 0.406069 0 0.906979C0 1.40789 0.406069 1.81396 0.906979 1.81396H1.85541C3.04991 1.81396 4.10474 2.59302 4.45602 3.73471L7.71725 14.3337C8.30273 16.2365 10.0608 17.5349 12.0516 17.5349H19.9752C21.9778 17.5349 23.7434 16.2213 24.3188 14.3031L26.2371 7.90911C26.8772 5.77537 25.2794 3.62792 23.0517 3.62792H6.34886C6.3396 3.62792 6.33037 3.62806 6.32118 3.62833L6.18977 3.20125C5.60429 1.29844 3.84625 0 1.85541 0H0.906979ZM9.45099 13.8002L6.87919 5.44188H23.0517C24.0643 5.44188 24.7906 6.41799 24.4996 7.38787L22.5814 13.7819C22.2361 14.9328 21.1768 15.721 19.9752 15.721H12.0516C10.8571 15.721 9.80228 14.9419 9.45099 13.8002ZM11.7907 21.1628C10.9559 21.1628 10.2791 21.8396 10.2791 22.6744C10.2791 23.5093 10.9559 24.186 11.7907 24.186C12.6256 24.186 13.3024 23.5093 13.3024 22.6744C13.3024 21.8396 12.6256 21.1628 11.7907 21.1628ZM8.46514 22.6744C8.46514 20.8377 9.95406 19.3488 11.7907 19.3488C13.6274 19.3488 15.1163 20.8377 15.1163 22.6744C15.1163 24.5111 13.6274 26 11.7907 26C9.95406 26 8.46514 24.5111 8.46514 22.6744ZM21.4652 21.1628C20.6303 21.1628 19.9535 21.8396 19.9535 22.6744C19.9535 23.5093 20.6303 24.186 21.4652 24.186C22.3 24.186 22.9768 23.5093 22.9768 22.6744C22.9768 21.8396 22.3 21.1628 21.4652 21.1628ZM18.1396 22.6744C18.1396 20.8377 19.6285 19.3488 21.4652 19.3488C23.3019 19.3488 24.7908 20.8377 24.7908 22.6744C24.7908 24.5111 23.3019 26 21.4652 26C19.6285 26 18.1396 24.5111 18.1396 22.6744Z",
    fill: "url(#paint0_radial_8832_5294)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8832_5294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6756 2.67338) rotate(149.04) scale(49.3685 590.433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0545299,
    stopColor: "#FF3767",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FF5864",
    stopOpacity: 0.990635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BB19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic-cart.f94a68714ca1ccad9480cdc4629685ae.svg";
export { ForwardRef as ReactComponent };